import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import emiCalculator from "../../Assets/Projects/emi_calculator.png";
import sanyukt from "../../Assets/Projects/sanyukt.png";
import aigrowthexaLanding from "../../Assets/Projects/aigrowthexa_landing.png";
import aigrowthexa from "../../Assets/Projects/aigrowthexa.png";
import gurunanakPharmacy from "../../Assets/Projects/gurunanak_pharmacy.png";


function Projects() {
  const [showMore, setShowMore] = useState(false);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gurunanakPharmacy}
              isBlog={false}
              title="Inventory Tracking System"
              description="A robust MERN stack online pharmacy store and inventory tracking system (Gurunanak Pharmacy). Enables customers to purchase healthcare products, upload medical prescriptions, and book diagnostic laboratory tests. Includes a dedicated administration panel to manage inventory levels, process customer orders, review prescription requests, and view sales analytics charts."
              ghLink="https://github.com/prashantsingh428/Guru-Nanak-Inventary-System.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emiCalculator}
              isBlog={false}
              title="MERN EMI & Prepayment Calculator"
              description="A feature-rich Home Loan EMI Calculator and Prepayment Planning dashboard built using the MERN stack. Features interactive inputs, pixel-perfect dynamic HTML5 Canvas-based pie charts showing Principal vs Interest, prepayment savings analytics (interest saved and tenure reduction), a year-by-year paginated amortization schedule, and an automated help desk chatbox."
              ghLink="https://github.com/prashantsingh428/EMI-Loan-Calculator.git"
              demoLink="https://emi-loan-calculator-ruddy.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sanyukt}
              isBlog={false}
              title="Sanyukt Parivaar MLM"
              description="A comprehensive Full-Stack Multi-Level Marketing (MLM) and E-commerce platform built with React, Node.js, Express, and MongoDB. Features complex binary matching algorithms with daily capping control, recursive team-downline tree traversal, real-time PV/BV calculations, commission payout engines, secure JWT/OTP authentication, and Razorpay payment gateway integration."
              ghLink="https://github.com/prashantsingh428/SanyuktProject.git"
              demoLink="https://sanyuktparivarrichlifefamily.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aigrowthexaLanding}
              isBlog={false}
              title="AI Growth Exa Landing Page"
              description="A highly-optimized, conversion-focused landing page for an AI Marketing Agency built using React, Vite, and Tailwind CSS. Features futuristic glassmorphic sections including custom trust statistics, customer testimonials, case studies, service list components, contact forms, and interactive FAQ widgets."
              ghLink="https://github.com/prashantsingh428/aigrowthexa-landing.git"
              demoLink="https://aigrowthexa.com/"
            />
          </Col>

          {showMore && (
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={aigrowthexa}
                isBlog={false}
                title="AI Growth Exa Platform"
                description="A robust MERN stack application for an AI-Based Marketing Agency. Provides automated social media marketing tools, AI campaign generation, marketing analytics reporting with customized data charts, active campaign budget distribution, role-based admin panels, and unified environment routing."
                ghLink="https://github.com/prashantsingh428/Ai-Growth-Exa.git"
                demoLink="https://health.aigrowthexa.com/"
              />
            </Col>
          )}


        </Row>

        {!showMore && (
          <Row style={{ justifyContent: "center", paddingTop: "20px", position: "relative", zIndex: 9999 }}>
            <button
              className="btn btn-primary"
              onClick={() => setShowMore(true)}
              style={{ maxWidth: "200px", position: "relative", zIndex: 9999 }}
            >
              View More
            </button>
          </Row>
        )}
      </Container>
    </Container>
  );
}

export default Projects;
